import ArcadeEmbed from "@pages/Site/components/ArcadeEmbed";
import React from "react";

const TakeTour = () => {
  return (
    <section className="pt-16 pb-8  2xl:h-[calc(100vh-96px)] h-[calc(100vh-75px)] md:pb-[6rem] w-full flex flex-col items-center justify-center  bg-white snap-start transition-all duration-700">
      <div className="w-full flex flex-col justify-center items-center pb-24 md:pb-0 text-center md:max-w-7xl 2xl:max-w-[90%] h-full md:h-auto mt-[4.5rem]">
        <ArcadeEmbed width={"100%"} heightIncremenet={"100px"} />
      </div>
    </section>
  );
};

export default TakeTour;
